<template>
  <v-dialog width="auto" v-model="dialog_creation" @click:outside="$store.commit('close_create_setting_dialog')">
    <v-card>
      <v-card-title>
        ساخت تنظیمات جدید
      </v-card-title>
      <v-card-text>
        <v-text-field
            v-model="new_settings_name"
            label="نام تنظیمات"
            required
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" flat @click="$store.commit('close_create_setting_dialog')">
          لغو
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="create_new_settings">
          ثبت
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "CreateSettingDialog",
  computed: {
    ...mapState({
      dialog_creation: state => state.Admin.settings.create_setting_dialog.show,
      loading: state => state.Admin.settings.loading,
      settings: state => state.Admin.settings.list
    }),
  },
  data() {
    return {
      new_settings_name: ''
    }
  },
  methods: {
    create_new_settings() {
      this.$store.dispatch('create_setting', {"title": this.new_settings_name}).then(() => {
        this.settings.push({
          "id": 1,
          "title": this.new_settings_name,
          "fields": []
        })
        this.new_settings_name = ""
      })
    }
  },
}
</script>

<style scoped>

</style>
